<template>
  <a-drawer width="1400px" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>查看详情</b>
    </a-divider>
    <div class="lineC">
      <a-form layout="vertical">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="选择时间" prop="deviceId">
              <div class="queryTime">
                <a-range-picker
                  format="YYYY-MM-DD"
                  @change="onChange"
                  :default-value="[moment(startTime, 'YYYY-MM-DD'), moment(endTime, 'YYYY-MM-DD')]"
                >
                  <!-- <template slot="renderExtraFooter">
                  extra footer
                </template> -->
                </a-range-picker>
                <a-button type="primary" @click="handleQuery" style="margin-left: 30px"
                  ><a-icon type="search" />查询</a-button
                >
                <div class="loca_time">{{ locationDescription }}</div>
              </div>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div class="pubLoading" v-show="!showLoading">
        <a-icon slot="indicator" type="loading" style="font-size: 80px" spin />
      </div>
      <div class="lineChar_y" v-show="showLoading">
        <div class="lineChart_l">
          <div class="lineChart_l_l">
            <lineChart :chartData="chartData" v-if="chartData && chartData.time && chartData.time.length"></lineChart>
          </div>
          <div class="lineChart_l_l">
            <lineCharts
              :chartData="chartData1"
              v-if="chartData1 && chartData1.time && chartData1.time.length"
            ></lineCharts>
          </div>
        </div>
        <div class="lineChart_l">
          <div class="lineChart_l_l">
            <lineCharts
              :chartData="chartData2"
              v-if="chartData2 && chartData2.time && chartData2.time.length"
            ></lineCharts>
          </div>
          <div class="lineChart_l_l">
            <lineChart14
              :chartData="chartData4"
              v-if="chartData4 && chartData4.time && chartData4.time.length"
            ></lineChart14>
          </div>
        </div>
        <div class="lineChart_l">
          <div class="lineChart_l_l">
            <lineCharts
              :chartData="chartData3"
              v-if="chartData3 && chartData3.time && chartData3.time.length"
            ></lineCharts>
          </div>

          <div class="lineChart_l_l">
            <!-- <lineCharts
              :chartData="chartData3"
              v-if="chartData3 && chartData3.time && chartData3.time.length"
            ></lineCharts> -->
          </div>
        </div>
        <div class="kong" v-if="chartData && chartData.time && chartData.time.length == 0">
          <img src="~@/assets/images/kong.png" alt="" />
          <div>暂无数据</div>
        </div>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import { getObj } from '@/api/saifuneng/devicedata'
import lineChart from '../../../Charts/lineChart.vue'
import lineCharts from '../../../Charts/lineChart13.vue'
import lineChart14 from '../../../Charts/lineChart14.vue'
import moment from 'moment'
export default {
  name: 'CreateForm',
  props: {},
  components: {
    lineChart,
    lineCharts,
    lineChart14
  },
  data() {
    return {
      submitLoading: false,
      showLoading: false,
      chartData1: {},
      queryParam: {},
      chartData4: {},
      deviceId: '',
      chartData2: {},
      queryTime: '',
      startTime: '',
      endTime: '',
      chartData3: {},
      formTitle: '',
      customList: [],
      chartData: {},
      locationDescription: '',
      // 表单参数
      form: {
        id: null,
        name: null,
        pieceArea: null,
        acPieceArea: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [{ required: true, message: '类型名称不能为空', trigger: 'blur' }],
        pieceArea: [{ required: true, message: '试片面积不能为空', trigger: 'blur' }],
        acPieceArea: [{ required: true, message: '交流试片面积不能为空', trigger: 'blur' }]
      }
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    moment,
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        pieceArea: null,
        remark: null,
        acPieceArea: null
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    onChange(date, dateString) {
      this.startTime = dateString[0]
      this.endTime = dateString[1]
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    handleQuery() {
      // let startTime = moment(this.startTime).format('YYYY-MM-DD')
      // let endTime = moment(this.endTime).format('YYYY-MM-DD')
      this.showLoading = false
      this.handleUpdate(this.deviceId, this.startTime, this.endTime)
    },
    /** 修改按钮操作 */
    handleUpdate(deviceId, startTime, endTime) {
      this.deviceId = deviceId
      this.startTime = startTime
      this.endTime = endTime
      this.formType = 2
      this.open = true
      getObj({ deviceId, startTime: this.startTime, endTime: this.endTime }).then((res) => {
        res = res.data
        this.locationDescription = res.locationDescription
        const arr = []
        const arr1 = []
        const time = []
        const acCurrentFlowingThroughTheTestPiece = []
        const directCurrentFlowingThroughTheTestPiece = []
        const batteryLevel = []
        const signalStrength = []
        const batteryVoltage = []
        const sacrificialAnode = []
        const sacrificialAnodeVoltage = []
        const selfCorrosionPotential = []
        const acInterferenceVoltage = []
        res.dataList.forEach((item) => {
          arr.push(item.voff)
          arr1.push(item.electrifiedPotential)
          time.push(item.time)
          batteryLevel.push(item.batteryLevel)
          signalStrength.push(item.signalStrength)
          batteryVoltage.push(item.batteryVoltage)
          acInterferenceVoltage.push(item.acInterferenceVoltage)
          sacrificialAnode.push(item.sacrificialAnode)
          selfCorrosionPotential.push(item.selfCorrosionPotential)
          sacrificialAnodeVoltage.push(item.sacrificialAnodeVoltage)
          acCurrentFlowingThroughTheTestPiece.push(item.acCurrentFlowingThroughTheTestPiece)
          directCurrentFlowingThroughTheTestPiece.push(item.directCurrentFlowingThroughTheTestPiece)
        })
        this.chartData = {
          time: time,
          y1: arr,
          y2: arr1,
          name: '',
          limitMax1: res.limitMax1,
          limitMax2: res.limitMax2,
          limitMin1: res.limitMin1,
          limitMin2: res.limitMin2,
          key1: 'electrifiedPotentialShow',
          key2: 'voffShow',
          name1: '通电电位',
          name2: '断电电位'
        }
        // this.chartData1 = this.chartData
        this.chartData1 = {
          time: time,
          y1: acCurrentFlowingThroughTheTestPiece,
          y2: directCurrentFlowingThroughTheTestPiece,
          key1: 'acCurrentFlowingThroughTheTestPieceShow',
          key2: 'directCurrentFlowingThroughTheTestPieceShow',
          name1: '交流电流',
          name2: '直流电流',
          unit: 'mA',
          name: ''
        }
        this.chartData2 = {
          time: time,
          y1: sacrificialAnodeVoltage,
          y2: selfCorrosionPotential,
          key1: 'sacrificialAnodeVoltageShow',
          key2: 'selfCorrosionPotentialShow',
          name1: '牺牲阳极',
          name2: '自腐蚀电位',
          unit: 'V',
          name: ''
        }
        this.chartData3 = {
          time: time,
          y1: batteryVoltage,

          // y2: signalStrength,
          key1: 'batteryVoltageShow',
          name1: '电池电压',
          // name2: '信号强度',
          unit: 'V',
          name: ''
        }
        this.chartData4 = {
          time: time,
          y1: acInterferenceVoltage,
          key1: 'acInterferenceVoltageShow',
          name: ''
        }
        this.$forceUpdate()
        this.showLoading = true
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDeviceType(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addDeviceType(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less">
.lineC {
  width: 750px;
}

.kong {
  text-align: center;
}

.pubLoading {
  text-align: center;
}

.lineChart_l {
  display: flex;
  align-items: center;
  margin-bottom: 40px;

  .lineChart_l_l {
    width: 50%;
    height: 300px;
  }
}

.queryTime {
  display: flex;
  align-items: center;
  width: 1200px;
}

.lineChar_y {
  width: 1300px;
}

.loca_time {
  margin-left: 30px;
  font-size: 26px;
}
</style>
